import { axios } from '@Api/axiosClient';
import type { PaymentIntent } from '@Types/PaymentIntent.interface';

const baseUrl: string = 'api/Payment';

export const registerPaymentIntentApi = async (intent: PaymentIntent): Promise<PaymentIntent> => {
    const response = await axios.post(`${baseUrl}/RegisterPaymentIntent`, intent);
    return response.data;
};

export const getUpdatedIntentApi = async (intent: PaymentIntent): Promise<PaymentIntent> => {
    const response = await axios.post(`${baseUrl}/GetUpdatedIntent`, intent);
    return response.data;
};
